<template lang="pug">
el-card.card(shadow="hover" :style="cardStyle")
  .card-header-listagem
    h1.titulo {{ cardTitle }}
    el-button(
      v-if="showBtnAction"
      :type="btnType"
      @click="$emit('execAction')",
    )
      i(:class="btnIconClass")
      span &nbsp {{ btnActionTitle }}
  .card-body-listagem
    slot(name="body")

</template>

<script>
export default {

  props: {
    cardTitle: {
      type: String,
      required: true
    },

    showBtnAction: {
      type: Boolean,
      default: false
    },

    btnType: {
      type: String,
      default: 'success'
    },

    btnIconClass: {
      type: String
    },

    btnActionTitle: {
      type: String,
      default: ''
    },

    cardStyle: {
      default: () => ({
        'border-radius': '15px',
        'margin': '2%',
        'box-shadow': 'none',
        '-webkit-box-shadow': ' none'
      })
    }

  }

}
</script>

<style lang="scss" scoped>

h1 {
  font-size: 1.5rem;
  margin: 0;
}

.card {
  border-radius: 15px;
  margin: 2%;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.card-body-listagem {
  padding: 5px 15px;
}

.card-header-listagem {
  border: transparent;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  align-items: center;
  padding: 10px 15px;
  margin-top: 0;
  margin-bottom: 10px;
}

.titulo {
  color: #424242;
  font-size: 1.5rem;
}

@media (max-width: 780px) {
  .card-header-listagem {
    flex-direction: column;
    padding: 10px 5px;
    align-items: stretch;
  }
}
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Cards/CardListagem/CardListagem.vue